var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',{staticClass:"ma-auto py-5 form",attrs:{"noMenu":""}},[_c('v-img',{attrs:{"height":"36","contain":"","position":"left center","src":"/static/logo_u.svg"}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }